import { useRouterState } from '@tanstack/react-router';

export const isPageActive = (page: string) => {
  const routerState = useRouterState();

  return routerState.location.pathname.includes(`/${page}`);
};
